import { render, staticRenderFns } from "./TeamStatsMain.vue?vue&type=template&id=0358418a&scoped=true&"
import script from "./TeamStatsMain.vue?vue&type=script&lang=js&"
export * from "./TeamStatsMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0358418a",
  null
  
)

export default component.exports